import { RecommendPlanResp } from 'app/bff/models/info/infoGetrecomplan';
import { ProductPolicyRulevalidateReq } from 'app/bff/models/product/productPolicyRulevalidate';
import { AaOtpSendcodeReq, AaOtpSendcodeResp } from 'app/bff/models/aa/aaOtpSendcode';
import { AaOtpVerifyReq } from 'app/bff/models/aa/aaOtpVerify';
import { PolicyTravelReq, PolicyTravelResp } from 'app/bff/models/policy/policyTravel';
import { PaymentCreditAuthReq } from 'app/bff/models/payment/paymentCreditAuth';
import { ProcessStepCodesEnum } from 'app/features/OnlineInsure/TravelInsurance/types';
import { FormValues as CalculationFormValues } from 'app/features/OnlineInsure/TravelInsurance/Calculation/types';
import { FormValues as InsuranceInfoFormValues } from 'app/features/OnlineInsure/TravelInsurance/InsuranceInfo/types';
import { FormValues as InsuranceInfoClausesFormValues } from 'app/features/OnlineInsure/TravelInsurance/InsuranceInfo/Clauses/types';
import { TravelInsuranceState, TravelInsuranceActions, INSURE_TRAVEL_INSURANCE__SAVE_RECOMMEND_PLAN_DATA, INSURE_TRAVEL_INSURANCE__INIT_PROCESS, INSURE_TRAVEL_INSURANCE__INIT_PROCESS_DONE, INSURE_TRAVEL_INSURANCE__SET_ACCESSIBLE_STEP, INSURE_TRAVEL_INSURANCE__SAVE_CALCULATION_PAGE_DATA, INSURE_TRAVEL_INSURANCE__VALIDATE_POLICY_RULES, INSURE_TRAVEL_INSURANCE__VALIDATE_POLICY_RULE_LAUNDERING_LIST, INSURE_TRAVEL_INSURANCE__SET_POLICY_STATUS, INSURE_TRAVEL_INSURANCE__SAVE_INSURANCE_INFO_PAGE_DATA, INSURE_TRAVEL_INSURANCE__SAVE_INSURANCE_INFO_CLAUSES_PAGE_DATA, INSURE_TRAVEL_INSURANCE__SEND_OTP, INSURE_TRAVEL_INSURANCE__SEND_OTP_DONE, INSURE_TRAVEL_INSURANCE__RESEND_OTP, INSURE_TRAVEL_INSURANCE__RESEND_OTP_DONE, INSURE_TRAVEL_INSURANCE__AUTH_OTP, INSURE_TRAVEL_INSURANCE__SEND_POLICY, INSURE_TRAVEL_INSURANCE__SEND_POLICY_DONE, INSURE_TRAVEL_INSURANCE__EXECUTE_CREDIT_CARD_PAYMENT, INSURE_TRAVEL_INSURANCE__UPDATE_CACHE, INSURE_TRAVEL_INSURANCE__RESET_CACHE } from './types';

/**
 * @description 緩存方案內容資料 (資料來源：旅平險介紹頁，熱門推薦區塊內的方案) (Action)
 * @param data 方案內容資料
 */
export const saveRecommendPlanDataAction = (data: RecommendPlanResp): TravelInsuranceActions => ({
  type: INSURE_TRAVEL_INSURANCE__SAVE_RECOMMEND_PLAN_DATA,
  payload: { data }
});

/**
 * @description 初始化流程 (初始取得相關資料) (Action)
 */
export const initProcessAction = (): TravelInsuranceActions => ({
  type: INSURE_TRAVEL_INSURANCE__INIT_PROCESS
});

/**
 * @description 初始化流程 (初始取得相關資料) 完成 (Action)
 * @param response 請求回傳的 Response
 */
export const initProcessDoneAction = (response: TravelInsuranceState['static']): TravelInsuranceActions => ({
  type: INSURE_TRAVEL_INSURANCE__INIT_PROCESS_DONE,
  payload: { response }
});

/**
 * @description 設置可訪問步驟 (Action)
 * @param step 當前步驟
 */
export const setAccessibleStepAction = (step: ProcessStepCodesEnum): TravelInsuranceActions => ({
  type: INSURE_TRAVEL_INSURANCE__SET_ACCESSIBLE_STEP,
  payload: { step }
});

/**
 * @description 緩存「計算保費」(Step-1) 資料 (Action)
 * @param data 頁面資料
 */
export const saveCalculationPageDataAction = (data: CalculationFormValues): TravelInsuranceActions => ({
  type: INSURE_TRAVEL_INSURANCE__SAVE_CALCULATION_PAGE_DATA,
  payload: { data }
});

/**
 * @description 執行保單規則檢核 (Action)
 * @param args 請求所需的參數
 * @param data 頁面資料
 */
export const validatePolicyRulesAction = (args: ProductPolicyRulevalidateReq, data: InsuranceInfoFormValues): TravelInsuranceActions => ({
  type: INSURE_TRAVEL_INSURANCE__VALIDATE_POLICY_RULES,
  payload: { args, data }
});

/**
 * @description 執行保單規則檢核 (洗錢名單) (Action)
 * @param args 請求所需的參數
 * @param data 頁面資料
 */
export const validatePolicyRuleLaunderingListAction = (args: ProductPolicyRulevalidateReq, data: InsuranceInfoFormValues): TravelInsuranceActions => ({
  type: INSURE_TRAVEL_INSURANCE__VALIDATE_POLICY_RULE_LAUNDERING_LIST,
  payload: { args, data }
});

/**
 * @description 設置保單狀態 (Action)
 * @param status 保單狀態
 */
export const setPolicyStatusAction = (status: TravelInsuranceState['policyStatus']): TravelInsuranceActions => ({
  type: INSURE_TRAVEL_INSURANCE__SET_POLICY_STATUS,
  payload: { status }
});

/**
 * @description 緩存「填寫資料」(Step-2-1) 資料 (Action)
 * @param data 頁面資料
 */
export const saveInsuranceInfoPageDataAction = (data: InsuranceInfoFormValues): TravelInsuranceActions => ({
  type: INSURE_TRAVEL_INSURANCE__SAVE_INSURANCE_INFO_PAGE_DATA,
  payload: { data }
});

/**
 * @description 緩存「填寫資料」(Step-2-2) 資料 (Action)
 * @param data 頁面資料
 */
export const saveInsuranceInfoClausesPageDataAction = (data: InsuranceInfoClausesFormValues): TravelInsuranceActions => ({
  type: INSURE_TRAVEL_INSURANCE__SAVE_INSURANCE_INFO_CLAUSES_PAGE_DATA,
  payload: { data }
});

/**
 * @description 發送 OTP 驗證碼 (Action)
 * @param args 請求所需的參數
 */
export const sendOTPAction = (args: AaOtpSendcodeReq): TravelInsuranceActions => ({
  type: INSURE_TRAVEL_INSURANCE__SEND_OTP,
  payload: { args }
});

/**
 * @description 發送 OTP 驗證碼 完成 (Action)
 * @param response 請求回傳的 Response
 */
export const sendOTPDoneAction = (response: AaOtpSendcodeResp): TravelInsuranceActions => ({
  type: INSURE_TRAVEL_INSURANCE__SEND_OTP_DONE,
  payload: { response }
});

/**
 * @description 重新發送 OTP 驗證碼 (Action)
 * @param args 請求所需的參數
 */
export const resendOTPAction = (args: AaOtpSendcodeReq): TravelInsuranceActions => ({
  type: INSURE_TRAVEL_INSURANCE__RESEND_OTP,
  payload: { args }
});

/**
 * @description 重新發送 OTP 驗證碼 完成 (Action)
 * @param response 請求回傳的 Response
 */
export const resendOTPDoneAction = (response: AaOtpSendcodeResp): TravelInsuranceActions => ({
  type: INSURE_TRAVEL_INSURANCE__RESEND_OTP_DONE,
  payload: { response }
});

/**
 * @description 驗證 OTP 驗證碼 (Action)
 * @param authOTPArgs 驗證 OTP 請求所需的參數
 * @param policyArgs 新增保單請求所需的參數
 */
export const authOTPAction = (authOTPArgs: AaOtpVerifyReq, policyArgs: PolicyTravelReq): TravelInsuranceActions => ({
  type: INSURE_TRAVEL_INSURANCE__AUTH_OTP,
  payload: { authOTPArgs, policyArgs }
});

/**
 * @description 送出保單 (新增保單) (Action)
 * @param args 請求所需的參數
 */
export const sendPolicyAction = (args: PolicyTravelReq): TravelInsuranceActions => ({
  type: INSURE_TRAVEL_INSURANCE__SEND_POLICY,
  payload: { args }
});

/**
 * @description 送出保單 (新增保單) 完成 (Action)
 * @param premiumTotal 總保費
 * @param response 請求回傳的 Response
 */
export const sendPolicyDoneAction = (premiumTotal: number, response: PolicyTravelResp): TravelInsuranceActions => ({
  type: INSURE_TRAVEL_INSURANCE__SEND_POLICY_DONE,
  payload: { premiumTotal, response }
});

/**
 * @description 執行信用卡繳費 (Action)
 * @param args 請求所需的參數
 */
export const executeCreditCardPaymentAction = (args: PaymentCreditAuthReq): TravelInsuranceActions => ({
  type: INSURE_TRAVEL_INSURANCE__EXECUTE_CREDIT_CARD_PAYMENT,
  payload: { args }
});

/**
 * @description 更新資料緩存 (Action)
 * @param cache 緩存資料
 */
export const updateCacheAction = (cache: TravelInsuranceState): TravelInsuranceActions => ({
  type: INSURE_TRAVEL_INSURANCE__UPDATE_CACHE,
  payload: { cache }
});

/**
 * @description 重置資料緩存 (Action)
 */
export const resetCacheAction = (): TravelInsuranceActions => ({
  type: INSURE_TRAVEL_INSURANCE__RESET_CACHE
});
